import { uiLanguage, type UiLanguage } from "../uiText";

/**
 * Textele vizibile ale părții de commerce, într-un singur loc.
 *
 * Până pe 10 aug 2026 aici era o singură limbă, româna, „fiindcă POC-ul rulează
 * pe magazinul demo cu catalog românesc". Alegerea era corectă pentru magazinul
 * ăla și greșită ca regulă: „Adaugă în coș" pe un magazin englezesc e exact
 * greșeala din oglindă cu salutul englezesc de pe un sit românesc. Acum urmează
 * `business.language`, ca tot restul chrome-ului (`uiText.ts`).
 */
export interface CommerceCopy {
  addToCart: string;
  viewProduct: string;
  recommended: string;
  soldOut: string;
  added: string;
  quantityUpdated: string;
  removed: string;
  cartFailed: string;
  /**
   * Linia pe care agentul voia s-o schimbe nu mai e în coș (WooCommerce lucrează
   * pe cheia liniei, deci absența ei e o stare pe care o vedem explicit - vezi
   * `woocommerce.ts`). Textul e pentru OM, iar agentul îl primește în
   * `lastActionError` și corectează verbal.
   */
  cartLineMissing: string;
  /** Eticheta panoului de carduri din modul de voce (screen readers). */
  suggestionsLabel: string;
  closePanel: string;
  /** Antetul pop-up-ului de comparație. */
  comparisonLabel: string;
  /** Eticheta de deasupra verdictului, în același pop-up. */
  verdictLabel: string;
}

const COMMERCE_COPY: Record<UiLanguage, CommerceCopy> = {
  ro: {
    addToCart: "Adaugă în coș",
    viewProduct: "Vezi produsul",
    recommended: "recomandat",
    soldOut: "Stoc epuizat",
    added: "Adăugat în coș",
    quantityUpdated: "Coșul a fost actualizat",
    removed: "Scos din coș",
    cartFailed: "Coșul nu a răspuns. Încearcă din nou.",
    cartLineMissing: "Produsul nu mai e în coș.",
    suggestionsLabel: "Produse recomandate",
    closePanel: "Închide",
    comparisonLabel: "Comparație",
    verdictLabel: "Pe scurt",
  },
  en: {
    addToCart: "Add to cart",
    viewProduct: "View product",
    recommended: "recommended",
    soldOut: "Sold out",
    added: "Added to cart",
    quantityUpdated: "Cart updated",
    removed: "Removed from cart",
    cartFailed: "The cart did not respond. Please try again.",
    cartLineMissing: "That product is no longer in the cart.",
    suggestionsLabel: "Recommended products",
    closePanel: "Close",
    comparisonLabel: "Comparison",
    verdictLabel: "In short",
  },
};

/**
 * Copy-ul de commerce pentru limba appului (`business.language`, brut).
 *
 * Fără argument dă româna: singurul magazin pe care rulează stratul de commerce
 * e demo-ul românesc, iar testele lui îl descriu în română. Când `sdk.ts` chiar
 * pornește runtime-ul, limba vine din config - vezi `CommerceRuntime`.
 */
export function commerceText(language?: string): CommerceCopy {
  return COMMERCE_COPY[language === undefined ? "ro" : uiLanguage(language)];
}
